/**
 * 全局混合
 */
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Common extends Vue {
  protected title: string[] = ['二手车业务'];
  // 表单相关
  protected reportId: number = 1;
  protected level: number = 1;
  protected store_group_id: number | null = null;
  protected loading: boolean = true;
  // 日历相关
  protected start: Date | string = new Date();
  protected end: Date | string = new Date();
  public created() {
    this.reportId = ~~this.$route.query.report_id;
    this.level = ~~this.$route.query.level;
  }
  public dateFromChild(...data: string[]) {
    [this.start, this.end] = data;
  }
  public titleFromChild(...data: string[]) {
    if (this.level === 1) {
      this.title.splice(1, 1, data[0]);
    } else {
      this.title.splice(1, 1, data[0]);
      this.title.splice(2, 1, data[1]);
    }
  }
  public levelFromChild(...data: number[]) {
    [this.level] = data;
  }
  public loadingFromChild(...data: boolean[]) {
    [this.loading] = data;
  }
}
